import { bootToolPage } from '../lib/boot-tool'
import { collectMetrics, onMetricsChange } from '../lib/metrics'

bootToolPage('home')

function paintStatus(): void {
  const m = collectMetrics()
  const set = (sel: string, text: string) => {
    document.querySelectorAll(sel).forEach((node) => {
      node.textContent = text
    })
  }
  set('[data-home-res]', `${m.cssWidth}×${m.cssHeight}`)
  set('[data-home-dpr]', `DPR ${m.dpr}`)
  set('[data-home-ratio]', m.aspectRatio)
}
paintStatus()
onMetricsChange(paintStatus)
